<script setup>
// A foto e o PDF que foram com a pergunta, dentro da bolha dela: a miniatura da foto, ou o nome do
// PDF. A bolha do texto e a da nota de voz (A-16, a foto que foi com a voz) mostram os mesmos.
//
// O clique abre o visor, só para ver (`abrir`, com a posição). O PDF abre pelo endereço do servidor
// ou pelo arquivo que o turno guarda para reenviar; sem nenhum dos dois, é só o nome.
defineProps({
  // Os anexos da bolha, com o `arquivo` do turno ao lado (`anexosDaBolha`, na conversa).
  anexos: { type: Array, required: true },
});

const emit = defineEmits(['abrir']);

const abreNoVisor = anexo => Boolean(anexo.url || anexo.arquivo);
</script>

<template>
  <div class="flex flex-wrap justify-end gap-1.5">
    <template v-for="(anexo, i) in anexos" :key="i">
      <button
        v-if="anexo.tipo === 'imagem' && anexo.url"
        type="button"
        class="overflow-hidden rounded-lg size-24 hover:opacity-90"
        @click="emit('abrir', i)"
      >
        <img
          :src="anexo.url"
          :alt="anexo.nome"
          class="object-cover size-full"
          data-anexo="imagem"
        />
      </button>
      <component
        :is="abreNoVisor(anexo) ? 'button' : 'span'"
        v-else
        :type="abreNoVisor(anexo) ? 'button' : undefined"
        class="flex items-center min-w-0 gap-1 px-2 py-1 text-xs rounded-lg bg-n-alpha-2"
        :class="{ 'hover:bg-n-alpha-3': abreNoVisor(anexo) }"
        data-anexo="arquivo"
        @click="abreNoVisor(anexo) && emit('abrir', i)"
      >
        <i class="shrink-0 i-lucide-file-text" />
        <span class="truncate max-w-44">{{ anexo.nome }}</span>
      </component>
    </template>
  </div>
</template>
